"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('creative', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", null, _react.default.createElement("g", null), _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M10.5 6H37.5C39.9853 6 42 8.01472 42 10.5V37.5C42 39.9853 39.9853 42 37.5 42H10.5C8.01472 42 6 39.9853 6 37.5V10.5C6 8.01472 8.01472 6 10.5 6Z",
    fill: props.outFillColor,
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M23.9993 18.3157L21.1037 24.2261L14.5263 25.1799L19.291 29.8381L18.1521 36.3157L23.9993 33.1985L29.8478 36.3157L28.7172 29.8381L33.4737 25.1799L26.9327 24.2261L23.9993 18.3157Z",
    fill: props.innerFillColor,
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M18.3158 12.6316H29.6842",
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }))));
});

exports.default = _default;